import moment from 'moment';

const START_OF_DAY = '00:00';
const END_OF_DAY = '23:59';

const formattedOOHTime = time => moment(time).format('HH:mm');

const getDayNameWithTimeSlot = (startTime, formattedTimeSlot, intl) => {
  const dayName = startTime.locale(intl.locale).format('dddd');

  return { name: dayName, timeSlot: formattedTimeSlot };
};

const getElapsedDays = (timeSlot, intl) => {
  const startTime = moment(timeSlot.from);
  const endTime = moment(timeSlot.to);

  const elapsedDays = [];

  if (startTime.isSame(endTime, 'date')) {
    const formattedTimeSlot = { start: formattedOOHTime(timeSlot.from), end: formattedOOHTime(timeSlot.to) };
    elapsedDays.push(getDayNameWithTimeSlot(startTime, formattedTimeSlot, intl));
  } else {
    let index = 0;

    while (startTime.locale(intl.locale).format('dddd') !== endTime.locale(intl.locale).format('dddd')) {
      let formattedTimeSlot;
      if (index === 0) {
        formattedTimeSlot = { start: formattedOOHTime(timeSlot.from), end: END_OF_DAY };
      } else {
        formattedTimeSlot = { start: START_OF_DAY, end: END_OF_DAY };
      }
      elapsedDays.push(getDayNameWithTimeSlot(startTime, formattedTimeSlot, intl));

      startTime.add(1, 'days');
      index += 1;
    }
    const formattedTimeSlot = { start: START_OF_DAY, end: formattedOOHTime(timeSlot.to) };
    elapsedDays.push(getDayNameWithTimeSlot(startTime, formattedTimeSlot, intl));
  }

  return elapsedDays;
};

export const groupOperationHoursInDays = (operationHours, intl) => {
  return operationHours.reduce((acc, timeSlot) => {
    getElapsedDays(timeSlot, intl).forEach((day) => {
      if (!Object.keys(acc).includes(day.name)) {
        acc[day.name] = [day.timeSlot];
      } else {
        acc[day.name].push(day.timeSlot);
      }
    });

    return acc;
  }, {});
};

export const getCurrentWeekStartEndTimeStamp = () => {
  const date = moment();
  return {
    startTimestamp: date.startOf('week').valueOf(),
    endTimestamp: date.endOf('week').valueOf(),
  };
};
